import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createBlock as _createBlock, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, isRef as _isRef, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5f050724"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "flex flexInput"
}
const _hoisted_2 = /*#__PURE__*/_createTextVNode("银行打款")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("支付宝打款")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("微信打款")
const _hoisted_5 = {
  key: 1,
  class: "flexBox mb24"
}
const _hoisted_6 = { class: "detail-item mb24" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "item-label" }, "房东联系方式：", -1))
const _hoisted_8 = { class: "item-value text-overflow2" }
const _hoisted_9 = { class: "detail-item" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "item-label" }, "打款方式：", -1))
const _hoisted_11 = { class: "item-value text-overflow2" }
const _hoisted_12 = { class: "detail-item" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "item-label" }, "打款账号：", -1))
const _hoisted_14 = { class: "item-value text-overflow2" }
const _hoisted_15 = { class: "flex flexUpload" }

import change from "@/composables/change";
import { ref, reactive, withDefaults, nextTick } from "vue";
import {
  houseRentApplyApi, //房屋租赁提交
  houseRentDetailApi, //房屋租赁申请
  houseRentTurnApi, //房屋租赁回传
} from "@/api/businessChange";
import { File, NodeItem } from "@/types/procss";
import { isEmpty } from "@/utils/type";
import type { FormInstance } from "ant-design-vue";
import Image from "@/components/Image.vue";

export default /*#__PURE__*/_defineComponent({
  props: {
    BranchCompanyFlowId: { default: 0 },
    preData: { default: () => [] },
    reEdit: { type: Boolean, default: false },
    update: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props as { BranchCompanyFlowId: number, preData: NodeItem[], reEdit: boolean, update: boolean }


const isEditFile = ref<boolean>(false); //文件是否可编辑
const IsSQWTEdit = ref<boolean>(false); //授权委托是否可编辑 true可编辑
const IsZLBAEdit = ref<boolean>(false); //租赁备案是否可编辑 true可编辑
const IsWYXYEdit = ref<boolean>(false); //物业协议是否可编辑 true可编辑

const turnFormRef = ref<FormInstance>(); //房屋租赁回传
let turn = reactive<Record<string, any>>({
  //回传展示
  PageFiles: [],
});
let turnDecproModel = reactive<Record<string, any>>({
  //弹窗回传
  PageFiles: [],
});

// 校验房东联系方式
const validatePhone = (rule, value) => {
  const regExp = /^1\d{10}$/;
  if (isEmpty(value)) {
    return Promise.reject("请输入房东联系方式");
  } else if (value && !regExp.test(value)) {
    return Promise.reject("请输入正确的手机号格式");
  } else {
    return Promise.resolve();
  }
};
//校验打卡账号
const validateAccount = (rule, value) => {
  const regExp = /\d{5}|\d{30}/;
  if (isEmpty(value)) {
    return Promise.reject("请输入打款账号");
  } else if (!regExp.test(value.replace(/\s*/g, ""))) {
    return Promise.reject("请输入5-30位的打款账号");
  } else {
    return Promise.resolve();
  }
};
//打款账号格式化
const handlePaymentAccountInput = (e: any) => {
  const o = e.target;
  const value = o.value.toString();
  nextTick(() => {
    FormData.PageData.BankAccount = value
      .replace(/\D/g, "")
      .replace(/(\d{4})(?=\d)/g, "$1 ");
  });
};

const IsFirstZLBAEdit = ref<boolean>(false); //是否第一次上传租赁备案
const IsFirstSQWTEdit = ref<boolean>(false); //是否第一次上传授权委托
const IsFirstWYXYEdit = ref<boolean>(false); //是否第一次上传物业协议
//上传附件
const handleUpload = (file: File, index?: number) => {
  if (!file) {
    if (isShowModel.value) {
      turnDecproModel.PageFiles[index as number] = {};
    } else {
      FormData.PageFiles[index as number] = {};
    }
  } else {
    if (isShowModel.value) {
      turnDecproModel.PageFiles[index as number] = {
        ...file,
        FileUrl: file.Url,
      };
    } else {
      if (!FormData.PageFiles[index] || !FormData.PageFiles[index].FileUrl) {
        if (index == 2) {
          //判断审批页面是否有删除标识
          IsFirstZLBAEdit.value = true; //是否第一次提交
        } else if (index == 3) {
          IsFirstSQWTEdit.value = true; //是否第一次提交
        } else if (index == 4) {
          IsFirstWYXYEdit.value = true; //是否第一次提交
        }
      }
      FormData.PageFiles[index] = {
        ...file,
        FileUrl: file.Url,
      };
    }
  }
};

// 表单字段定义
const FormData = reactive({
  PageFiles: [],
  PageData: {
    ContactMobile: "",
    BankAccount: "",
    PaymentWay: 1,
  },
});

//封装方法字段
const FormRef = ref();
const common = reactive({
  ApplyApi: houseRentApplyApi,
  DetailApi: houseRentDetailApi,
  FormData: FormData,
  nodeIdx: 3,
  FormRef: FormRef,
  turnDecpro: turn,
  turnApi: houseRentTurnApi,
  turnFormRef: turnFormRef,
  turnDecproModel: turnDecproModel,
  isEditFile: isEditFile,
  IsSQWTEdit: IsSQWTEdit,
  IsZLBAEdit: IsZLBAEdit,
  IsWYXYEdit: IsWYXYEdit,
  IsFirstEdit1: IsFirstZLBAEdit,
  IsFirstEdit2: IsFirstSQWTEdit,
  IsFirstEdit3: IsFirstWYXYEdit,
  props: props,
});

const {
  edit,
  isShowModel,
  submitTurnaroundDecproApply,
  winHeight,
  actionButtons,
} = change(common);

return (_ctx: any,_cache: any) => {
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_a_form, {
      style: _normalizeStyle({ minHeight: _unref(winHeight) + 'px' }),
      model: _unref(FormData),
      ref_key: "FormRef",
      ref: FormRef,
      validateTrigger: "blur",
      class: _normalizeClass(["form-upload", !_unref(edit) ? 'border-bottom mb24' : '']),
      labelAlign: "left",
      colon: false
    }, {
      default: _withCtx(() => [
        (_unref(edit) || __props.BranchCompanyFlowId == 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createVNode(_component_a_form_item, {
                label: "房东联系方式",
                name: ['PageData', 'ContactMobile'],
                rules: [{ required: true, message: '请输入房东联系方式' }]
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_input, {
                    placeholder: "请填写",
                    value: _unref(FormData).PageData.ContactMobile,
                    "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_unref(FormData).PageData.ContactMobile) = $event)),
                    maxlength: "30",
                    disabled: !isEditFile.value
                  }, null, 8, ["value", "disabled"])
                ]),
                _: 1
              }),
              _createVNode(_component_a_form_item, {
                label: "打款方式",
                name: ['PageData', 'PaymentWay'],
                rules: [{ required: true, message: '请选择打款方式' }]
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_select, {
                    value: _unref(FormData).PageData.PaymentWay,
                    "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_unref(FormData).PageData.PaymentWay) = $event)),
                    placeholder: "请选择",
                    disabled: !isEditFile.value
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_select_option, { value: 1 }, {
                        default: _withCtx(() => [
                          _hoisted_2
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_select_option, { value: 2 }, {
                        default: _withCtx(() => [
                          _hoisted_3
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_select_option, { value: 3 }, {
                        default: _withCtx(() => [
                          _hoisted_4
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["value", "disabled"])
                ]),
                _: 1
              }),
              _createVNode(_component_a_form_item, {
                label: "打款账号",
                name: ['PageData', 'BankAccount'],
                rules: [{ required: true, message: '请输入打款账号' }]
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_input, {
                    placeholder: "请填写",
                    value: _unref(FormData).PageData.BankAccount,
                    "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_unref(FormData).PageData.BankAccount) = $event)),
                    disabled: !isEditFile.value
                  }, null, 8, ["value", "disabled"])
                ]),
                _: 1
              })
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _hoisted_7,
                _createElementVNode("span", _hoisted_8, _toDisplayString(_unref(FormData).PageData.ContactMobile), 1)
              ]),
              _createElementVNode("div", _hoisted_9, [
                _hoisted_10,
                _createElementVNode("span", _hoisted_11, _toDisplayString(_unref(FormData).PageData.PaymentWayText), 1)
              ]),
              _createElementVNode("div", _hoisted_12, [
                _hoisted_13,
                _createElementVNode("span", _hoisted_14, _toDisplayString(_unref(FormData).PageData.BankAccount), 1)
              ])
            ])),
        _createElementVNode("div", _hoisted_15, [
          _createVNode(_component_a_form_item, {
            name: ['PageFiles', 0, 'FileUrl'],
            label: "房屋租赁合同",
            rules: [{ required: true, message: '请上传房屋租赁合同' }],
            class: "form-upload-item"
          }, {
            default: _withCtx(() => [
              _createVNode(Image, {
                value: 
            _unref(FormData).PageFiles[0] && _unref(FormData).PageFiles[0].FileUrl
              ? _unref(FormData).PageFiles[0].FileUrl
              : ''
          ,
                "disable-close": !(isEditFile.value && _unref(edit)),
                disable: !!__props.preData || !_unref(edit),
                "file-type": '931',
                onUpload: _cache[3] || (_cache[3] = (file) => handleUpload(file, 0))
              }, null, 8, ["value", "disable-close", "disable"])
            ]),
            _: 1
          }),
          (
          _unref(turn).PageFiles &&
          _unref(turn).PageFiles.length > 0 &&
          _unref(turn).PageFiles[0]?.FileUrl
        )
            ? (_openBlock(), _createBlock(_component_a_form_item, {
                key: 0,
                name: "turn",
                label: "房屋租赁合同(回传)",
                class: "form-upload-item"
              }, {
                default: _withCtx(() => [
                  _createVNode(Image, {
                    value: 
            _unref(turn).PageFiles && _unref(turn).PageFiles.length > 0
              ? _unref(turn).PageFiles[0]?.FileUrl
              : ''
          ,
                    "disable-close": true,
                    disable: true,
                    "file-type": '9311'
                  }, null, 8, ["value"])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_a_form_item, {
            name: ['PageFiles', 1, 'FileUrl'],
            label: "房产证复印件",
            rules: [{ required: true, message: '请上传房产证复印件' }],
            class: "form-upload-item"
          }, {
            default: _withCtx(() => [
              _createVNode(Image, {
                value: 
            _unref(FormData).PageFiles[1] && _unref(FormData).PageFiles[1].FileUrl
              ? _unref(FormData).PageFiles[1].FileUrl
              : ''
          ,
                "disable-close": !(isEditFile.value && _unref(edit)),
                disable: !!props.preData || !_unref(edit),
                "file-type": '932',
                onUpload: _cache[4] || (_cache[4] = (file) => handleUpload(file, 1))
              }, null, 8, ["value", "disable-close", "disable"])
            ]),
            _: 1
          }),
          _createVNode(_component_a_form_item, {
            label: "租赁备案（若有）",
            class: "form-upload-item"
          }, {
            default: _withCtx(() => [
              _createVNode(Image, {
                value: _unref(FormData).PageFiles[2] && _unref(FormData).PageFiles[2].FileUrl,
                "disable-close": !(IsFirstZLBAEdit.value || (IsZLBAEdit.value && _unref(edit))),
                disable: !!__props.preData || !(_unref(edit) || _unref(actionButtons).includes('-3')),
                "file-type": '911',
                onUpload: _cache[5] || (_cache[5] = (file) => handleUpload(file, 2))
              }, null, 8, ["value", "disable-close", "disable"])
            ]),
            _: 1
          }),
          _createVNode(_component_a_form_item, {
            label: "授权委托书（若有）",
            class: "form-upload-item"
          }, {
            default: _withCtx(() => [
              _createVNode(Image, {
                value: _unref(FormData).PageFiles[3] && _unref(FormData).PageFiles[3].FileUrl,
                "disable-close": !(IsFirstSQWTEdit.value || (IsSQWTEdit.value && _unref(edit))),
                disable: !!__props.preData || !(_unref(edit) || _unref(actionButtons).includes('-3')),
                "file-type": '912',
                onUpload: _cache[6] || (_cache[6] = (file) => handleUpload(file, 3))
              }, null, 8, ["value", "disable-close", "disable"])
            ]),
            _: 1
          }),
          _createVNode(_component_a_form_item, {
            label: "物业协议（若有）",
            class: "form-upload-item"
          }, {
            default: _withCtx(() => [
              _createVNode(Image, {
                value: _unref(FormData).PageFiles[4] && _unref(FormData).PageFiles[4].FileUrl,
                "disable-close": !(IsFirstWYXYEdit.value || (IsWYXYEdit.value && _unref(edit))),
                disable: !!__props.preData || !(_unref(edit) || _unref(actionButtons).includes('-3')),
                "file-type": '913',
                onUpload: _cache[7] || (_cache[7] = (file) => handleUpload(file, 4))
              }, null, 8, ["value", "disable-close", "disable"])
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    }, 8, ["style", "model", "class"]),
    _createVNode(_component_a_modal, {
      class: "modal-dialog",
      visible: _unref(isShowModel),
      "onUpdate:visible": _cache[9] || (_cache[9] = ($event: any) => (_isRef(isShowModel) ? (isShowModel).value = $event : null)),
      title: "房屋租赁合同回传",
      onOk: _unref(submitTurnaroundDecproApply),
      onCancel: _cache[10] || (_cache[10] = ($event: any) => (turnFormRef.value.resetFields()))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_form, {
          ref_key: "turnFormRef",
          ref: turnFormRef,
          model: _unref(turnDecproModel),
          validateTrigger: "blur",
          layout: "vertical",
          colon: false
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_form_item, {
              name: ['PageFiles', 0, 'FileUrl'],
              label: "房屋租赁合同",
              class: "form-upload-item",
              rules: [{ required: true, message: '请回传房屋租赁合同' }]
            }, {
              default: _withCtx(() => [
                _createVNode(Image, {
                  value: 
            _unref(turnDecproModel).PageFiles[0] && _unref(turnDecproModel).PageFiles[0].FileUrl
          ,
                  "disable-close": false,
                  onUpload: _cache[8] || (_cache[8] = (file) => handleUpload(file, 0)),
                  "file-type": '9311'
                }, null, 8, ["value"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"])
      ]),
      _: 1
    }, 8, ["visible", "onOk"])
  ], 64))
}
}

})